/**
 * Estado de sesión del cliente — SEC-001.
 *
 * Este módulo sustituye a `tokenStore.ts`, que guardaba el JWT en `localStorage`. Ya no
 * existe ningún token que guardar: la credencial vive en una cookie `HttpOnly` que el
 * JavaScript de la página **no puede leer**, de modo que un XSS no tiene nada que
 * exfiltrar. El navegador la adjunta solo en cada petición.
 *
 * Lo único que queda aquí es (a) leer la cookie CSRF —que sí es legible a propósito— para
 * el doble envío, y (b) avisar cuando el servidor responde 401.
 */

/** Nombre de la cookie CSRF. Debe coincidir con `CSRF_COOKIE_NAME` del backend. */
const CSRF_COOKIE_NAME = 'agos_csrf'

/** Cabecera de doble envío. Debe coincidir con `CSRF_HEADER_NAME` del backend. */
export const CSRF_HEADER_NAME = 'X-CSRF-Token'

let unauthorizedHandler: (() => void) | null = null

/**
 * Lee la cookie CSRF emitida por el login.
 *
 * No es una credencial: no autentica a nadie y por sí sola no sirve. Su valor está en que
 * un sitio atacante **no puede leerla** —la política de mismo origen se lo impide—, así
 * que no puede construir la cabecera aunque logre que el navegador envíe la cookie.
 */
export function readCsrfToken(): string | null {
  const prefix = `${CSRF_COOKIE_NAME}=`
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim()
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length))
    }
  }
  return null
}

export function setUnauthorizedHandler(handler: (() => void) | null): void {
  unauthorizedHandler = handler
}

export function notifyUnauthorized(): void {
  unauthorizedHandler?.()
}
